import React from 'react';
import PropTypes from 'prop-types';
import by from 'thenby';
import { SearchSelect } from 'ui-kit';

export const PLACEHOLDER = 'Select artist type...';
export const NO_RESULTS_PLACEHOLDER = 'No artist type found.';

const toOption = ({ id, name }) => ({
    value: id,
    label: name,
});

const SelectArtistType = ({
    placeholder = PLACEHOLDER,
    noResultsPlaceholder = NO_RESULTS_PLACEHOLDER,
    disabled = false,
    value,
    artistTypes = [],
    onChange = () => {},
}) => (
    <SearchSelect
        placeholder={placeholder}
        noResultsPlaceholder={noResultsPlaceholder}
        value={value}
        isDisabled={disabled}
        options={artistTypes.sort(by('name')).map(toOption)}
        onChange={onChange}
    />
);

SelectArtistType.propTypes = {
    placeholder: PropTypes.string,
    noResultsPlaceholder: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    artistTypes: PropTypes.array,
    onChange: PropTypes.func,
};

export default SelectArtistType;
